import Project from "../../../components/Project";

const works = [
  {
    date: [{ month: "Aug", year: "2025" }],
    photoURL: "./img/restaurant.jpg",
    linkUrl: "quickbite-restuarant-template.netlify.app/",
  },
  {
    date: [{ month: "Jun", year: "2025" }],
    photoURL: "./img/aspen.jpg",
    linkUrl: "aspenhi-tech.ca/",
  },
  {
    date: [{ month: "May", year: "2025" }],
    photoURL: "./img/my-money.jpg",
    linkUrl: "",
  },
  {
    date: [{ month: "Jan", year: "2024" }],
    photoURL: "./img/metrix.jpg",
    linkUrl: "metrix-self.vercel.app/",
  },
  {
    date: [{ month: "Aug", year: "2023" }],
    photoURL: "./img/Money-grow.png",
    linkUrl: "money-grow.netlify.app/",
  },
  {
    date: [{ month: "Apr", year: "2023" }],
    photoURL: "./img/alarado.jpg",
    linkUrl: "alarado.netlify.app/",
  },
];

export default function Work() {
  return (
    <section className="work">
      <div>
        <span className="span">/ Works</span>
        <h3>Selected works,</h3>
        <h3>Clients projetcs.</h3>
        <p>
          My goal is to create visually stunning and functional websites that
          provide an exceptional user experience and help businesses thrive
          online.
        </p>
        <h1 className="heading">Design & Code</h1>
      </div>
      <ul>
        {works.map((work) => (
          <a
            href={`https://${work.linkUrl}`}
            target="_blank"
            key={work.photoURL}
          >
            <Project work={work} />
          </a>
        ))}
      </ul>
    </section>
  );
}
